import { ChangesAlerts } from '../../types'
import { pubSubAlerts } from './pubSub'

export const state = {
    alerts: new Map<number, ChangesAlerts>(),
    unread: 0,
}

export const HARD_LIMIT = 100

export const DEFAULT_CONFIG = {
    isPublicShow: [true],
    isTruePrivate: [true],
    isOnlyPrivate: [true],
    isGroupShow: [true],
    isClubShow: [true],
    isOffline: [true],
    isOnline: [true],
    isAway: [true],
}

export const insertAlerts = (alerts: Array<ChangesAlerts>) => {
    const uniqueAlerts = new Map()

    alerts.forEach((alert) => {
        const { key, id } = alert

        if (state.alerts.has(id)) {
            const { unread } = state.alerts.get(id)
            if (unread) {
                state.unread--
            }
            state.alerts.delete(id)
        }

        if (key === 'isAway' || key === 'isOffline') {
            return
        }

        state.unread++

        uniqueAlerts.set(id, { ...alert, unread: true })
    })

    const incomingAlerts = Array.from(uniqueAlerts)
    const existingAlerts = Array.from(state.alerts)

    state.alerts = new Map(
        [...incomingAlerts, ...existingAlerts].slice(0, HARD_LIMIT),
    )

    pubSubAlerts.emit('ALERT', {
        alerts: incomingAlerts.map(([, alert]) => alert),
        unread: state.unread,
    })

    incomingAlerts.forEach(([id, alert]) => {
        pubSubAlerts.emit('ALERT::' + id, {
            unread: state.unread,
            alerts: [alert],
        })
    })
}

export const resetUnread = () => {
    state.alerts = new Map(
        Array.from(state.alerts).map(([id, alert]) => [
            id,
            { ...alert, unread: false },
        ]),
    )
    state.unread = 0
}

export const clearAlerts = () => {
    state.alerts = new Map<number, ChangesAlerts>()
    state.unread = 0
    pubSubAlerts.emit('ALERT', {
        alerts: state.alerts,
        unread: state.unread,
    })
}
